export default "__VITE_ASSET__7ae417ca__"